import { createContext, useState } from 'react';
import api from 'services/api';

export const OrçamentosContext = createContext();

export const OrçamentosProvider = ({ children }) => {
  const [orçamentos, setOrçamentos] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const [getLoading, setGetLoading] = useState(false);

  const getOrçamentos = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: orçamentos?.filter,
        page: orçamentos?.page,
        size: orçamentos?.size,
        order: orçamentos?.order,
        ...payload,
      });
      setOrçamentos((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <OrçamentosContext.Provider
      value={{
        orçamentos,
        getLoading,
        getOrçamentos,
      }}
    >
      {children}
    </OrçamentosContext.Provider>
  );
};
